var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c("h3", [_vm._v("RL 3.5 Rekapitulasi Kunjungan")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("DataTable", {
        attrs: {
          "table-id": "table-pasien",
          title: "Rekapitulasi Kunjungan",
          "filter-configs": _vm.filterConfigs,
          "table-options": _vm.tableOptions,
          "show-filter": true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }